import imageMale from 'assets/img/icons/avatar-male.svg';
import AIUtils from 'services/AIUtils';

class AdminUtils {
  getAssistantUser(admins) {
    return Object.values(admins).find((a) => a.name === AIUtils.getAssistantName());
  }

  getName(admin) {
    let error = 'Unknown Name';

    if (!admin) return error;

    let name = '';

    if (admin.name !== undefined) name = admin.name;

    name = name.trim();

    if (name === '') name = error;

    return name;
  }

  getPhotoUrls(admin) {
    return [admin?.photo, imageMale];
  }
}

export default new AdminUtils();
